import React, { type JSX } from 'react';
import starIcon from '@/assets/svg/static/star.svg';
import { Carousel } from '@/components/features';
import { updatedImageUrl } from '@/utils/formatting';
import styles from './ProductDetailCarousel.module.css';
import type { ProductDetailCarouselProps } from './ProductDetailCarousel.types';

export const ProductDetailCarousel = React.memo(
  ({
    productDetails,
    allImages,
    ratingVal,
    ratingCountVal,
    onTryOnClick,
    onImageClick,
  }: ProductDetailCarouselProps): JSX.Element => {
    return (
      <div className={styles.carouselFrame}>
        <div className={styles.productImage}>
          <Carousel
            images={allImages.map(updatedImageUrl)}
            altPrefix={productDetails.name}
            onImageClick={onImageClick}
          />

          {/* Play/Video Try-on Button on Left */}
          <div className={styles.videoTryOnThumbnail} onClick={onTryOnClick}>
            <img src={updatedImageUrl(productDetails.imageUrl)} />
            <div className={styles.playIconOverlay}>
              <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>

          <div className={styles.carouselRatingBadge}>
            <div className={styles.ratingRow}>
              <span className={styles.ratingText}>
                {Number(ratingVal).toFixed(1)}
              </span>
              <img src={starIcon} alt="" className={styles.starIcon} />
            </div>
            <span className={styles.ratingCountText}>
              {ratingCountVal} ratings
            </span>
          </div>
        </div>
      </div>
    );
  }
);

export default ProductDetailCarousel;
